'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _adminUserAddForm = require('./admin-user-add-form.component');

var _adminUserAddForm2 = _interopRequireDefault(_adminUserAddForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.admin.adminUserAddForm', []).component('adminUserAddForm', _adminUserAddForm2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/admin/admin-users/admin-user-add-form/admin-user-add-form.module.js